import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import icon1 from "../Assets/Images/users.svg";
import banImg from "../Assets/Images/bannerImg.png";
import { useParams } from "react-router-dom";
import { clientDetailsGet } from "../services/Service";
import InnerBanner from "../Components/InnerBanner";
import { TestimonialV2 } from "../Components/TestimonialV2";
import { Loader } from "../Components/Loader";
import { PageMetaTitle } from "../Components/PageMetaTitle";
import { clientStoryMeta } from "../services/metaTags";

export const ClientStoryDetail = () => {
  const [data, setData] = useState([]);
  const [card, setCard] = useState([]);
  const params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const pathName = window.location.pathname;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathName]);

  useEffect(() => {
    clientDetailsGet(params?.url, setData, setIsLoading, params?.id);
    clientDetailsGet(
      params?.url,
      setCard,
      setIsLoading,
      `${params?.id}/?_fields=acf&acf_format=standard`
    );
  }, [params]);

  var bannerContent = {
    cardTitle: card?.acf?.our_client_heading,
    cardPara: data?.acf?.csdp_sub_heading,
  };
  return (
    <>
     <PageMetaTitle data={clientStoryMeta}/>
      {isLoading && <Loader />}
      <InnerBanner
        bannerCnt={bannerContent}
        banImg={
          card?.acf?.story_cover_image ? card?.acf?.story_cover_image : banImg
        }
      />

      {data?.title?.rendered || card?.acf?.our_client_descrition ? (
        <section className="target-seo sec-padding">
          <Container>
            {data?.title?.rendered && (
              <h2 className="sec-heading  text-center">
                {data?.title?.rendered}
              </h2>
            )}
            {card?.acf?.our_client_descrition && (
              <div
                className="sub-heading  text-center custom-list"
                dangerouslySetInnerHTML={{
                  __html: card?.acf?.our_client_descrition,
                }}
              ></div>
            )}
            <div className="simple_Img mt-5 text-center">
              <img  loading="lazy"  width="" height=""  
                src={card?.acf?.our_client_image}
                className="img-fluid"
                alt={"our_client_image"}
              />
            </div>

            {/* Counter Card */}
            {card?.acf?.cs_counter_box && (
              <div className="target-body">
                <div className="case-study-cards">
                  {card?.acf?.cs_counter_box?.length > 0 &&
                    card?.acf?.cs_counter_box?.map((item, i) => {
                      return (
                        <div className="case-study-card" key={i}>
                          <img  loading="lazy"  width="" height=""   src={icon1} alt="icon1" />
                          <h3>{item?.cs_counter_box_number}</h3>
                          <p>{item?.cs_counter_box_heading}</p>
                        </div>
                      );
                    })}
                </div>
              </div>
            )}
          </Container>
        </section>
      ) : (
        ""
      )}
      {card?.acf?.our_challenge_content_box?.length > 0 && (
        <section
          className="award-sec sec-padding single-cstm-cards"
          style={{ backgroundColor: "#fff" }}
        >
          <Container>
            <h2 className="sec-heading">{data?.security_assessment_heading}</h2>
            {card?.acf?.our_challenge_content_box?.length > 0 &&
              card?.acf?.our_challenge_content_box?.map((item, i) => {
                if (i % 2 === 0) {
                  return (
                    <div
                      key={i}
                      className={
                        i > 1
                          ? "complex-chng-des chng-des-md reverse loop mt-lg-5 mt-3 content_card"
                          : "complex-chng-des chng-des-md content_card reverse loop"
                      }
                    >
                      <div className="cmpx-chng-des ">
                        <div className="ltd-case-description custom-list">
                          {item?.our_challenge_headiing && (
                            <h3>{item?.our_challenge_headiing}</h3>
                          )}
                          {item?.our_challenge_content && (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: item?.our_challenge_content,
                              }}
                            ></div>
                          )}
                        </div>
                      </div>
                      <div className="cmpx-img-card simple_Img">
                        <img  loading="lazy"  width="" height=""  
                          src={item?.our_challenge_image}
                          className="img-fluid"
                          alt="our_challenge_image"
                        />
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <div
                      className="complex-chng-des chng-des-md  mt-lg-5 mt-3 content_card"
                      key={i}
                    >
                      <div className="cmpx-img-card simple_Img">
                        <img  loading="lazy"  width="" height=""  
                          src={item?.our_challenge_image}
                          className="img-fluid"
                          alt="our_challenge_image2"
                        />
                      </div>
                      <div className="cmpx-chng-des ">
                        <div className="ltd-case-description custom-list">
                          {item?.our_challenge_headiing && (
                            <h3>{item?.our_challenge_headiing}</h3>
                          )}
                          {item?.our_challenge_content && (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: item?.our_challenge_content,
                              }}
                            ></div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                }
              })}
          </Container>
        </section>
      )}

      <div className="bg-light">
        <TestimonialV2 />
      </div>
    </>
  );
};
